import image from 'assets/images/wall1.jpg';
import './styles.scss';

export default function AsideContent(){
  return(
    <div className="aside-content middle-column">
      <img className="main-picture main-picture--second" src={image} alt="logo" />
    </div>
  );
}